import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class Effect {
  constructor(props = {}) {
    _defineProperty(this, "id", void 0);

    _defineProperty(this, "props", void 0);

    _defineProperty(this, "useInPicking", void 0);

    const {
      id = 'effect'
    } = props;
    this.id = id;
    this.props = { ...props
    };
    this.useInPicking = false;
  }

  preRender() {}

  getModuleParameters(layer) {}

  cleanup() {}

}
//# sourceMappingURL=effect.js.map